import { render, staticRenderFns } from "./SlidePopinModalFilter.vue?vue&type=template&id=b96fe55e&scoped=true"
import script from "./SlidePopinModalFilter.vue?vue&type=script&lang=js"
export * from "./SlidePopinModalFilter.vue?vue&type=script&lang=js"
import style0 from "./SlidePopinModalFilter.vue?vue&type=style&index=0&id=b96fe55e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b96fe55e",
  null
  
)

export default component.exports